import React from "react";

import { Alert, AlertTitle, Box, Button, Stack } from "@mui/material";

import { useLanguage } from "../../config/language/language";

/**
 * In-page explanation when the menu cannot load (auth / network / server).
 * Replaces an infinite loading spinner after a failed fetch.
 */
export default function MenuAccessMessage({ error, requiresLogin, isLoggedIn, onRetry, onSignIn }) {
    const LANG = useLanguage();
    const status = error?.status;

    const needsSignIn =
        status === 401 ||
        status === 403 ||
        (requiresLogin && !isLoggedIn && (status == null || status === 0));

    let title = LANG.MENU_LOAD_ERROR_TITLE;
    let body = LANG.MENU_LOAD_ERROR_BODY;

    if (status === 403) {
        title = LANG.MENU_FORBIDDEN_TITLE;
        body = LANG.MENU_FORBIDDEN_BODY;
    } else if (status === 401 || (requiresLogin && !isLoggedIn && !error)) {
        title = LANG.MENU_ACCESS_REQUIRED_TITLE;
        body = LANG.MENU_ACCESS_REQUIRED_BODY;
    } else if (status === 503) {
        title = LANG.MENU_UNAVAILABLE_TITLE;
        body = LANG.MENU_UNAVAILABLE_BODY;
    } else if (status === 0) {
        title = LANG.MENU_LOAD_ERROR_TITLE;
        body = LANG.SNACKBAR_ERROR_SERVER;
    }

    return (
        <Box sx={{ mt: 4, maxWidth: 520, mx: "auto", px: 1 }}>
            <Alert severity={needsSignIn ? "warning" : "error"} variant="outlined">
                <AlertTitle>{title}</AlertTitle>
                {body}
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mt: 2 }}>
                    {needsSignIn && (
                        <Button variant="contained" size="small" onClick={onSignIn}>
                            {LANG.MENU_GO_LOGIN}
                        </Button>
                    )}
                    {typeof onRetry === "function" && (
                        <Button variant="outlined" size="small" onClick={onRetry}>
                            {LANG.MENU_RETRY}
                        </Button>
                    )}
                </Stack>
            </Alert>
        </Box>
    );
}
